import { gql } from '@apollo/client';

export default gql`
  mutation createMultiSuppliers($data: String) {
    createMultiSuppliers(data: $data) {
      ok
      message
      error
    }
  }
`;
